import React, { useState, useEffect } from "react";
import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import viewIcon from "../../../../../Assets/icons/eye 1.svg";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import { IoMdClose } from "react-icons/io";

const SupervisorPartAllocationList = () => {
  const [jobCardData, setJobCardData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchSevicePartList(newPage);
  };

  const formatDataForDownload = (data, headers, keyMapping) => {
    const csvHeaders = headers.map((header) => keyMapping[header]);
    const csvRows = data.map((item) => {
      return headers
        .map((header) => {
          const key = keyMapping[header];
          return item[key];
        })
        .join(",");
    });
    const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
    return csvContent;
  };

  const handleEdit = (rowData) => {
    navigate("spare-part-Allocation-Details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Job Id",
    "Job Card Date",
    "Product Name",
    "Make",
    "Model",
    "Variant",
    "Color",
    "Spare Part Name",
    "Supervisor Name",
    "Price",
    "Qty",
    "Status",
    "Action",
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Job Id": "job_card_no",
    "Job Card Date": "transaction_date",
    "Product Name": "product_name",
    Make: "make_name",
    Model: "model_name",
    Variant: "variant_name",
    Color: "color_name",
    "Supervisor Name": "supervisor_name",
    "Spare Part Name": "item_name",
    Price: "job_estimate_amount",

    Qty: "good_qty",
    // "Business Partner ID": "onboard_id",
    Status: "Status",
    Action: [
      // {
      //   type: "edit",
      //   icon: editIcon,
      //   label: "Edit",
      // },
      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
    ],
  };

  const fetchSevicePartList = async (page = 0, pageSize = 1) => {
    const allfilteredData = filters;
    try {
      const response = await axiosInstance.post(
        "/sparepartallocation/sparepartallocationlist",
        {
          business_partner_id: 1,
          fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
          toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
          orderBy: "job_card_id desc",
          page,
          pageSize,
          searchText: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        Status: item?.solved == 0 ? "Pending" : "Done",
      }));
      setTotalRecords(response?.data?.data?.totalRecords);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setJobCardData(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  useEffect(() => {
    fetchSevicePartList();
  }, []);

  useEffect(() => {
    fetchSevicePartList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchSevicePartList();
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
  ];

  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.targrt.value);
  };

  const heandelOnkeyDown = (event) => {
    if (event.key === "Enter") fetchSevicePartList();
  };

  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2">
          <h5 style={{fontWeight:"600"}} >Spare Part Allocation</h5>
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView">
          <div className="filterLeftView pt-4 col-md-4 gap-2">
            <h5 style={{fontWeight:"600"}} >Spare Part Allocation List</h5>
            <div className="searchinput-wrapper">
              <input
                type="text"
                className="searchinput"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchInputChange}
                onKeyDown={heandelOnkeyDown}
              />
              {searchTerm ? (
                <IoMdClose
                  size={22}
                  className="searchinput-close-icon"
                  onClick={clearSearchAndFetch}
                />
              ) : (
                <img
                  src={searchIcon}
                  alt="Search"
                  className="searchinput-icon"
                />
              )}
            </div>
          </div>
          <div className="filterRightView col-md-8 gap-2">
            <h5 style={{paddingTop:"30px"}} >Filter By</h5>
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
              // onSubmit={handleFormSubmit}
            />
          </div>
        </div>

        <CustomTable
          data={jobCardData}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          onEdit={handleEdit} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleViewButton={handleEdit}
          totalRecords={totalRecords}
        />
      </div>
    </div>
  );
};

export default SupervisorPartAllocationList;
